import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "play-outline-icon",
  role: "img",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M8.426 2.6h.002l12.037 7.53c1.374.872 1.388 2.864-.006 3.73h-.002L8.427 21.4C6.951 22.33 5 21.302 5 19.543V4.458C5 2.698 6.952 1.67 8.426 2.6Zm-.8 1.269c-.507-.32-1.126.048-1.126.589v15.084c0 .54.62.91 1.126.589l.003-.002 12.038-7.544a.695.695 0 0 0-.005-1.189L7.63 3.871l-.003-.002Z"
    }, null, -1)
  ])))
}
export default { render: render }